import { Component, OnInit } from '@angular/core';
import { OnboardingService } from '../../onboarding.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-setup-password',
  templateUrl: './setup-password.component.html',
  styleUrls: ['./setup-password.component.scss']
})
export class SetupPasswordComponent implements OnInit {
  resetForm!: FormGroup;
  submitted = false;
  errorMessage:any
  showError:any;
  constructor(private onboardingService: OnboardingService, private fb: FormBuilder, private router: Router) { }

  ngOnInit(): void {
    this.resetForm = this.fb.group({
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(30)])],
      confrimPassword: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(30)])]
    }, { validator: this.matchPassword2('password', 'confrimPassword') });
    if(!history.state.email && !history.state.token){
      this.router.navigate(['/login'])
    }
  }

  handleSuccess(data) {
    console.log(data);
  }

  errored(event) {
    console.log('error', event)
  }

  onSubmit() {
    console.log(this.resetForm)
    this.submitted = true;
    this.showError=false;
    if (this.resetForm.valid) {
      let obj = {
        "password": this.resetForm.value.password,
        "emailAddress": history.state.email,
        "token": history.state.token
      }
      this.onboardingService.updateUserPassword(obj).subscribe((res) => {
        this.router.navigate(['/login'])
      }, err => {
        this.showError=true;
        if(err==500){
          this.errorMessage="Cannot use current password again."
        }
      })
    }

  }

  get resetFormControl() {
    return this.resetForm.controls;
  }

  matchPassword2(firstControl, secondControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.get(firstControl).value;
      const confirm = control.get(secondControl).value;
      if (password != confirm) { return { 'noMatch': true } }
      return null

    }
  }
}
